import { render, staticRenderFns } from "./gscy.vue?vue&type=template&id=6e71c37b&scoped=true&"
import script from "./gscy.vue?vue&type=script&lang=js&"
export * from "./gscy.vue?vue&type=script&lang=js&"
import style0 from "./gscy.vue?vue&type=style&index=0&id=6e71c37b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71c37b",
  null
  
)

export default component.exports